export default class NotificationSubscriptionController {
    static hideRecaptchaBanner() {
        const style = document.createElement('style');

        style.innerHTML = '.grecaptcha-badge { visibility: hidden; }';
        document.head.appendChild(style);
    }
}
